/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { interval, tap } from 'rxjs';
import { ConfigurationService } from '../../../core/services/configuration/configuration.service';
import { ChatbotService } from '../../../core/services/chatbot/chatbot.service';

@Component({
  selector: 'app-whatsapp-floating-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './whatsapp-floating-button.component.html',
  styleUrl: './whatsapp-floating-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhatsappFloatingButtonComponent implements OnInit, OnDestroy {
  phoneNumber = '';
  message = '';
  liveMode = localStorage.getItem('isLiveMode') === 'true' ? true : false;

  private liveModeCheckSub?: any;

  constructor(
    private appConfig: ConfigurationService,
    private chatbotService: ChatbotService
  ) {
    this.phoneNumber = `${this.appConfig.getPhoneNumber()}`;
    this.message = `${this.appConfig.getMessage()}`;

    this.chatbotService.getCurrentModeChatbotStatus().subscribe((isInLiveMode) => {
      localStorage.setItem('isLiveMode', isInLiveMode ? 'true' : 'false');
      this.liveMode = isInLiveMode;
    });
  }

  ngOnInit(): void {
    this.liveModeCheckSub = interval(60000).pipe(
      tap(() => {
        this.chatbotService.getCurrentModeChatbotStatus().subscribe((isInLiveMode) => {
          localStorage.setItem('isLiveMode', isInLiveMode ? 'true' : 'false');
          this.liveMode = isInLiveMode;
        });
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    if (this.liveModeCheckSub) {
      this.liveModeCheckSub.unsubscribe();
    }
  }

  get whatsAppUrl(): string {
    return `https://wa.me/${this.phoneNumber}?text=${encodeURIComponent(this.message)}`;
  }
}
